import type { ProductSearchByTextMenuFeatureOptions } from '../../../api/models/FeatureOptions';
import type { ProductSearchByTextMenuFeatureItem } from '../../../models/features/menu/ProductSearchByTextMenuFeatureItem';
import type { AppDispatch, RootState } from '../../../store/store';
import { getNewFeatureUuid } from '../../FeatureService';
import type { FeatureHandler } from '../FeatureHandler';

export const productSearchByTextMenuFeatureHandler = {
    startFeatureItem(
        dispatch: AppDispatch,
        state: RootState,
        featureOptions: ProductSearchByTextMenuFeatureOptions
    ): Promise<void> {
        dispatch.uiState.setMode('menu');
        dispatch.featureState.setMainFeatureItem(null);
        dispatch.featureState.setSidebarFeatureItem(null);
        dispatch.featureState.setMenuFeatureItem({
            featureUuid: getNewFeatureUuid('product-search-by-text-menu'),
            featureType: 'product-search-by-text-menu',
            searchText: featureOptions.searchText ?? ''
        });
        return Promise.resolve();
    }
} as const satisfies FeatureHandler<ProductSearchByTextMenuFeatureItem>;
